import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomePage from '@/views/home-page/index.vue'
import AppLayout from '@/layouts/index.vue'
import PageLayout from '@/layouts/pagelayout.vue'
import ApproveListPage from '@/views/approve-list-page/index.vue'
import Login from '@/views/login/index.vue'

Vue.use(VueRouter)
const routes: Array<RouteConfig> = []

// 通用路由 没有权限要求的基本页 可以供给所有角色 访问
export const constantRoutes: RouteConfig[] = [
  { path: '/404', component: () => import('@/layouts/404.vue') },
  { path: '/login', name: 'Login', component: Login }
]

// 需要根据用户角色动态加载的路由
// 产品总监 运营总监 运营专员 普通助教 教研总监 产品专员 销售顾问 【admin，只有权限管理权限】

export const asyncRoutes: RouteConfig[] = [
  {
    path: '/',
    component: AppLayout,
    redirect: '/home',
    children: [
      { path: 'home', name: 'home', component: HomePage, meta: { name: '首页', menu: true, roles: ['运营专员', '运营主管', '运营总监', '教研总监', '产品总监', '产品专员', '销售顾问', '质检总监'] } },
      { path: 'qa', name: 'qa', component: () => import('@/views/qa-page/index.vue'), meta: { name: '使用手册', menu: false } },
      { path: 'change_pwd', name: 'change_pwd', component: () => import('@/views/password-change-page/index.vue'), meta: { name: '修改密码', menu: false } },
      { path: 'system_message', name: 'system_message', component: () => import('@/views/system-message-page/index.vue'), meta: { name: '系统消息', menu: false } },
      {
        path: 'approve',
        component: PageLayout,
        meta: { name: '审批', menu: true, roles: ['产品总监', '运营总监', '产品专员', '运营专员', '销售顾问', '运营主管', '质检总监'] },
        children: [
          { path: 'list', name: 'list', component: ApproveListPage, meta: { name: '审批列表', menu: true, roles: ['产品总监', '运营总监', '产品专员', '运营主管', '质检总监'] } },
          { path: 'progress', name: 'progress', component: () => import('@/views/approve-progress-page/index.vue'), meta: { name: '审批进度', menu: true, roles: ['运营专员', '销售顾问', '产品总监', '运营主管', '质检总监'] } },
          { path: 'abnormal', name: 'abnormal', component: () => import('@/views/abnormal-approve-list-page/index.vue'), meta: { name: '异常审批', menu: true, roles: ['运营专员', '销售顾问', '运营主管', '质检总监'] } },
          { path: 'sign', name: 'sign', component: () => import('@/views/approve-detail-sign/index.vue'), meta: { name: '审批', menu: false } },
          { path: 'create', name: 'create', component: () => import('@/views/create-order-page/index.vue'), meta: { name: '工单创建', menu: false } },
          { path: 'classover', name: 'classover', component: () => import('@/views/approve-detail-classover/index.vue'), meta: { name: '结课审批', menu: false } },
          { path: 'anomaly', name: 'anomaly', component: () => import('@/views/approve-detail-anomaly/index.vue'), meta: { name: '异常审批详情', menu: false } }
        ]
      },
      {
        path: 'student',
        component: PageLayout,
        meta: { name: '学员管理', menu: true, roles: ['运营专员', '产品专员', '销售顾问', '运营总监', '普通助教', '教研总监', '产品总监', 'supervisor', '运营主管', '运营实习生', '运营实习生班长', '质检总监', '质检专员'] },
        children: [
          { path: 'join_class', name: 'join_class', component: () => import('@/views/join-class-list-page/index.vue'), meta: { name: '入班', menu: true, roles: ['产品总监', '产品专员', '质检总监'] } },
          { path: 'allocation_class', name: 'allocation_class', component: () => import('@/views/allocation-list-page/index.vue'), meta: { name: '分配班级', menu: true, roles: ['运营总监', '质检总监'] } },
          { path: 'create', name: 'create_student', component: () => import('@/views/create-student-page/index.vue'), meta: { name: '操作学员', menu: false } },
          { path: 'continue', name: 'continue', component: () => import('@/views/continue-student-page/index.vue'), meta: { name: '续报学员', menu: false } },
          { path: 'receive', name: 'receive', component: () => import('@/views/receive-list-page/index.vue'), meta: { name: '认领学员', menu: true, roles: ['运营专员', '运营主管', '质检总监'] } },
          { path: 'list', name: 'studen_list', component: () => import('@/views/student-list-page/index.vue'), meta: { name: '学员列表', keepAlive: true, menu: true } },
          {
            path: 'paper_list',
            name: 'paper_list',
            component: () => import('@/views/paper-list-page/index.vue'),
            meta: { name: '论文学员', keepAlive: true, menu: true, roles: ['运营专员', '运营实习生班长', '运营实习生', '产品专员', '销售顾问', '运营总监', '教研总监', '产品总监', '运营主管', '质检总监', '质检专员'] }
          },
          {
            path: 'class_list',
            name: 'class_list',
            component: () => import('@/views/class-list-page/index.vue'),
            meta: { name: '班级列表', keepAlive: true, menu: true, roles: ['运营专员', '运营总监', '教研总监', '产品总监', '普通助教', '产品专员', '运营主管', '运营实习生班长', '运营实习生', '质检专员'] }
          },
          { path: 'quality_class_list', name: 'quality_class_list', component: () => import('@/views/quality_class_list/index.vue'), meta: { name: '班级列表', keepAlive: true, menu: true, roles: ['质检总监'] } },
          {
            path: 'ipqclass_list',
            name: 'ipqclass_list',
            component: () => import('@/views/ipq-list-page/index.vue'),
            meta: { name: 'IEPQ班级列表', keepAlive: true, menu: true, roles: ['运营专员', '运营总监', '教研总监', '产品总监', '产品专员', 'supervisor', '运营主管', '质检总监', '质检专员', '运营实习生班长'] }
          },
          { path: 'class_management', name: 'class_management', component: () => import('@/views/class-management-page/index.vue'), meta: { name: '班级管理', keepAlive: true, menu: true, roles: ['运营总监', '产品总监'] } },
          { path: 'class_managementStudent', name: 'student_management', component: () => import('@/views/classStudent-list-page/index.vue'), meta: { name: '学员管理', menu: false } },
          { path: 'class_over', name: 'class_over', component: () => import('@/views/class-over-list/index.vue'), meta: { name: '结课班级', menu: true, keepAlive: true, roles: ['运营专员', '运营总监', '运营主管', '质检总监'] } },
          { path: 'course_start', name: 'course_start', component: () => import('@/views/start-course-page/index.vue'), meta: { name: '开课', menu: true, roles: ['运营专员', '教研总监', '运营总监', '运营主管', '运营实习生班长', '运营实习生'] } },
          { path: 'join', name: 'join', component: () => import('@/views/join-class-detail-page/index.vue'), meta: { name: '学员入班', menu: false } },
          { path: 'detail', name: 'detail', component: () => import('@/views/student-detail-page/index.vue'), meta: { name: '学员详情', menu: false } },
          { path: 'lunwenDetail', name: 'lunwenDetail', component: () => import('@/views/lunwenDetail-page/index.vue'), meta: { name: '结组详情', menu: false } },
          { path: 'lunwenDetail1', name: 'lunwenDetail1', component: () => import('@/views/lunwenDetail1-page/index.vue'), meta: { name: '结组详情', menu: false } },
          { path: 'studentLunwenDetail', name: 'studentLunwenDetail', component: () => import('@/views/studentLunwenDetail/index.vue'), meta: { name: '学生论文详情', menu: false } },
          { path: 'studentLunwenDetail1', name: 'studentLunwenDetail1', component: () => import('@/views/studentLunwenDetail1/index.vue'), meta: { name: '学生论文详情', menu: false } },
          { path: 'schedule', name: 'schedule', component: () => import('@/views/schedule-page/index.vue'), meta: { name: '课表查询', menu: true, roles: ['运营专员', '运营总监', '产品总监', '产品专员', '教研总监', '运营主管', '质检总监', '运营实习生班长', '运营实习生'] } },
          { path: 'class_detail', name: 'class_detail', component: () => import('@/views/class-detail-page/index.vue'), meta: { name: '班级详情', menu: false } },
          { path: 'class_abnormal_students', name: 'class_abnormal_students', component: () => import('@/views/class-abnormal-students/index.vue'), meta: { name: '结课班级异常学员', menu: false } },
          { path: 'feedback', name: 'feedback', component: () => import('@/views/feedback/index.vue'), meta: { name: '编辑反馈', menu: false } }
        ]
      },
      {
        path: 'database',
        component: PageLayout,
        meta: { name: '资料库', menu: false, roles: ['普通助教', '教研总监', '销售顾问', '运营专员', '运营总监', '产品专员', '产品总监', '运营主管'] },
        children: [
          { path: 'project_results', name: 'project_results', component: () => import('@/views/project-results/index.vue'), meta: { name: '项目成果', menu: true, type: 1, roles: ['运营专员', '运营总监', '产品专员', '产品总监', '教研总监', '销售顾问', '运营主管'] } },
          { path: 'project_certificate', name: 'project_certificate', component: () => import('@/views/project-certificate/index.vue'), meta: { name: '证书资料', menu: true, roles: ['运营专员', '运营总监', '产品专员', '产品总监', '教研总监', '销售顾问', '运营主管'] } },
          { path: 'project_information', name: 'project_information', component: () => import('@/views/project-results/index.vue'), meta: { name: '项目资料', menu: true, type: 2, roles: ['运营专员', '运营总监', '产品专员', '产品总监', '教研总监', '销售顾问', '运营主管'] } },
          { path: 'project_result_detail', name: 'project_result_detail', component: () => import('@/views/project-result-detail/index.vue'), meta: { name: '项目成果明细', menu: false, roles: ['运营专员', '运营总监', '产品专员', '教研总监', '产品总监', '销售顾问', '运营主管'] } },
          { path: 'batch_generation', name: 'batch_generation', component: () => import('@/views/batch-generation-page/index.vue'), meta: { name: '批量生成资料', menu: false, roles: ['运营专员', '运营总监', '产品专员', '产品总监', '教研总监', '销售顾问', '运营主管'] } }
        ]
      },
      {
        path: 'operate',
        component: PageLayout,
        meta: { name: '运营团队', menu: true, roles: ['运营总监'] },
        children: [
          { path: 'team_list', name: 'team_list', component: () => import('@/views/team-list-page/index.vue'), meta: { name: '运营团队', keepAlive: true, menu: true, roles: ['运营专员', '运营总监', '产品专员', '产品总监', '销售顾问', '运营主管'] } },
          { path: 'team_list_detail', name: 'team_list_detail', component: () => import('@/views/team-list-detail/index.vue'), meta: { name: '运营团队明细', menu: false, roles: ['运营专员', '运营总监', '产品专员', '产品总监', '销售顾问', '运营主管'] } }
        ]
      },
      {
        path: 'tutor',
        component: PageLayout,
        meta: { name: '导师库', menu: true, roles: ['教研总监', '运营专员', '运营总监', '运营主管'] },
        children: [
          { path: 'main_tutor', name: 'main_tutor', component: () => import('@/views/main-tutor-page/index.vue'), meta: { name: '主导师', keepAlive: true, type: 1, menu: true, roles: ['运营专员', '运营总监', '教研总监', '运营主管'] } },
          { path: 'mentor_tutor', name: 'mentor_tutor', component: () => import('@/views/mentor-tutor-page/index.vue'), meta: { name: 'Mentor库', keepAlive: true, type: 2, menu: true, roles: ['教研总监'] } },
          { path: 'paper_tutor', name: 'paper_tutor', component: () => import('@/views/paper-tutor-page/index.vue'), meta: { name: '论文导师库', keepAlive: true, type: 3, menu: true, roles: ['教研总监'] } },
          { path: 'ta_tutor', name: 'ta_tutor', component: () => import('@/views/ta-tutor-page/index.vue'), meta: { name: '科研助教导师', type: 4, keepAlive: true, menu: true, roles: ['教研总监'] } },
          { path: 'supervisor_tutor', name: 'supervisor_tutor', component: () => import('@/views/supervisor-tutor-page/index.vue'), meta: { name: 'Supervisor', keepAlive: true, type: 5, menu: true, roles: ['教研总监'] } },
          { path: 'main_tutor_detail', name: 'main_tutor_detail', component: () => import('@/views/main-tutor-detail/index.vue'), meta: { name: '主导师明细', menu: false } },
          { path: 'tutor_detail', name: 'tutor_detail', component: () => import('@/views/tutor-detail-page/index.vue'), meta: { name: '导师明细', menu: false } },
          { path: 'tutor_timetable', name: 'tutor_timetable', component: () => import('@/views/tutor-timetable-page/index.vue'), meta: { name: '导师课表', menu: false, roles: ['运营专员', '运营总监', '产品专员', '教研总监', '产品总监', '运营主管'] } }
        ]
      },
      {
        path: 'tateam',
        component: PageLayout,
        meta: { name: 'TA团队', menu: true, roles: ['运营专员', '运营总监', '产品总监', '运营主管'] },
        children: [
          { path: 'ta_team', name: 'ta_team', component: () => import('@/views/ta-team-page/index.vue'), meta: { name: '在职TA列表', keepAlive: true, menu: true, type: 1, roles: ['运营专员', '运营总监', '产品总监', '运营主管'] } },
          { path: 'ta_team_detail', name: 'ta_team_detail', component: () => import('@/views/ta-team-detail/index.vue'), meta: { name: 'TA个人详情', menu: false, roles: ['运营专员', '运营总监', '产品总监', '运营主管'] } },
          { path: 'ta_quit', name: 'ta_quit', component: () => import('@/views/taquit-team-page/index.vue'), meta: { name: '离职TA列表', keepAlive: true, menu: true, type: 2, roles: ['运营专员', '运营总监', '产品总监', '运营主管'] } }
        ]
      },
      {
        path: 'apply',
        component: PageLayout,
        meta: { name: '网申相关', menu: true, roles: ['运营专员', '运营总监', '运营主管'] },
        children: [
          { path: 'apply_info', name: 'apply_info', component: () => import('@/views/apply-info/index.vue'), meta: { name: '网申信息', keepAlive: true, menu: true, type: 1, roles: ['运营专员', '运营总监', '运营主管'] } },
          { path: 'apply_history', name: 'apply_history', component: () => import('@/views/apply-history/index.vue'), meta: { name: '网申历史', keepAlive: true, menu: true, roles: ['运营专员', '运营总监', '运营主管'] } },
          { path: 'apply_add', name: 'apply_add', component: () => import('@/views/apply-add/index.vue'), meta: { name: '批量修改网申资格', keepAlive: true, menu: true, type: 1, roles: ['运营总监'] } }
        ]
      },
      {
        path: 'employeeRole',
        component: PageLayout,
        meta: { name: '权限管理', menu: true, roles: ['admin'] },
        children: [{ path: 'employee_role', name: 'employee_role', component: () => import('@/views/employee-role-page/index.vue'), meta: { name: '员工角色', menu: true } }]
      },
      {
        path: 'employeeRole',
        component: PageLayout,
        meta: { name: '操作日志', menu: true, roles: ['admin'] },
        children: [{ path: 'journal', name: 'journal', component: () => import('@/views/journal/index.vue'), meta: { name: '操作日志', menu: true } }]
      },
      {
        path: 'message',
        component: PageLayout,
        meta: { name: '消息通知', menu: true, roles: ['教研总监'] },
        children: [
          { path: 'send_list', name: 'send_list', component: () => import('@/views/send-message-list-page/index.vue'), meta: { name: '发送列表', menu: true, roles: ['教研总监'] } },
          { path: 'template_list', name: 'template_list', component: () => import('@/views/template-manage-page/index.vue'), meta: { name: '模板管理', menu: true, roles: ['教研总监'] } },
          { path: 'email_edit', name: 'email_edit', component: () => import('@/views/email-template-edit-page/index.vue'), meta: { name: '邮件模板', menu: false } },
          { path: 'sms_edit', name: 'sms_edit', component: () => import('@/views/sms-template-edit-page/index.vue'), meta: { name: '短信模板', menu: false } }
        ]
      },
      { path: 'create_abnormal', name: 'create_abnormal', component: () => import('@/views/abnormal-create-page/index.vue'), meta: { name: '异常创建', menu: false } }
    ]
  },
  { path: '*', redirect: '/login' }
]

const createRouter = () =>
  new VueRouter({
    mode: 'history', // Disabled due to Github Pages doesn't support this, enable this if you need.
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
    base: process.env.BASE_URL,
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  ;(router as any).matcher = (newRouter as any).matcher
}

const originalPush: any = VueRouter.prototype.push // 避免重复点击home页面报错
VueRouter.prototype.push = function push (location: any) {
  return originalPush.call(this, location).catch((err: any) => err)
}

export default router
